import { LimitReportActionDispatch, LimitReportReduxTypes } from "./types";

export const createLimitReport = (payload: any): LimitReportActionDispatch => ({
    type: LimitReportReduxTypes.LIMIT_REPORT,
    payload: payload
})